<template>
	<view class="letter-popup" :class="{ 'letter-popup--show': visible }" @touchmove.stop.prevent="onMove">
		<view class="letter-popup__wrap">
			<image class="letter-popup__icon" src="@/static/images/notice.png" mode=""></image>
			<view class="letter-popup__title">{{ popup.title || t('siteLetter.title') }}</view>
			<view class="letter-popup__sender">{{ t('siteLetter.sender') }}: {{ popup.sendUser || t('siteLetter.systemSender') }}</view>
			<scroll-view class="letter-popup__main" scroll-y @touchmove.stop>
				<rich-text :nodes="popup.content"></rich-text>
			</scroll-view>
			<button class="ui-button ui-button--raduis" hover-class="ui-button--hover" @click="onClose">{{ t('noticePopup.gotIt') }}</button>
		</view>
		<image class="letter-popup__close" src="@/static/images/icons/close-popup.png" mode="" @click="onClose"></image>
	</view>
</template>

<script setup>
	import { computed } from 'vue';
	import { useI18n } from 'vue-i18n';
	import { useLetterStore } from '@/stores/letter.js';

	const { t } = useI18n();
	const letterStore = useLetterStore();

	const popup = computed(() => letterStore.pendingPopup || {});
	const visible = computed(() => !!letterStore.pendingPopup);

	function onClose() {
		const id = letterStore.pendingPopup?.id;
		if (id != null) letterStore.markRead([id]);
		letterStore.closePopup();
	}

	function onMove() {}
</script>

<style lang="scss" scoped>
	.letter-popup {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 999;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		background: rgba(0, 0, 0, .6);
		transform: scale(0);
		transition: all .3s;

		.ui-button {
			flex-shrink: 0;
			margin: 0 12rpx;
		}

		&--show {
			transform: scale(1);
		}

		&__close {
			display: block;
			width: 60rpx;
			height: 60rpx;
			margin: 60rpx auto 0;
		}

		&__wrap {
			position: relative;
			display: flex;
			flex-direction: column;
			width: 558rpx;
			max-height: 76vh;
			padding: 60rpx 60rpx 50rpx;
			background: #fff;
			border-radius: 32rpx;
			box-sizing: border-box;
		}

		&__main {
			flex: 1;
			min-height: 0;
			padding: 10rpx 0 30rpx;
			font-size: 28rpx;
			line-height: 1.8;
			color: #8C9098;
			word-break: break-word;
		}

		&__title {
			flex-shrink: 0;
			font-size: 40rpx;
			font-weight: bold;
			text-align: center;
			margin-top: 30rpx;
			word-break: break-word;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			overflow: hidden;
		}

		&__sender {
			flex-shrink: 0;
			margin-top: 12rpx;
			font-size: 24rpx;
			color: #B0B3B8;
			text-align: center;
		}

		&__icon {
			flex-shrink: 0;
			display: block;
			width: 316rpx;
			height: 154rpx;
			margin: auto;
		}
	}
</style>
